module.exports = __webpack_public_path__ + "img/space-triangle.6e87cd9f.webp";